import React, { useEffect, useState } from 'react';

import { FaReact, FaNodeJs, FaHtml5, FaBootstrap } from 'react-icons/fa';
import { DiJavascript1 } from 'react-icons/di';
import { SiMongodb, SiCss3, SiTailwindcss, SiRedux, SiFirebase } from 'react-icons/si';
import AOS from 'aos';
import 'aos/dist/aos.css';










import './Skills2.css'
import Wave from 'react-wavify';











import CountUp from 'react-countup';
import ScrollTrigger from 'react-scroll-trigger';
import useTitle from '../../Hooks/useTitle';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';





























const Skills2 = () => {

    const { language } = useLanguage()


    useTitle('Skills | Fahim Faysal');
    const { pathname } = useLocation();


    const [showDetails, setShowDetails] = useState(false)

    useEffect(() => {
        AOS.init({
            duration: 1500
        })
    }, [])

    const handleViewDetails = () => {
        setShowDetails(!showDetails);
    }


    const [countOn, setCountOn] = useState(false);
    const handleMouseEnter = () => {
        setCountOn(true);
    };
    const handleMouseLeave = () => {
        setCountOn(false);
    };












    return (
        <div className='mb-44'>

            {
                language === 'english' ?
                    <>
                        <h1 id='skills' className={`mt-8 uppercase text-center text-2xl sm:text-2xl md:text-4xl lg:text-5xl mb-16 font-mono ${pathname.includes('skills') ? 'sm:mt-10 md:mt-36 mt-32' : 'sm:mt-4 md:mt-0 mt-4'}`}>Professional <span className='text-rose-600 md:text-6xl text-4xl'>
                            Skills
                        </span>
                            {/* <hr className='mx-auto mt-4 ' width="230px" /> */}
                        </h1>
                        <div className=' -mt-[56px]  text-center lg:w-[530px] md:w-[445px] sm:w-[280px] w-[280px] h-[70px]       wavy'></div>
                    </>
                    :
                    <>
                        <h1 id='skills' className={`mt-8 uppercase text-center text-2xl sm:text-2xl md:text-4xl lg:text-5xl mb-16 font-mono ${pathname.includes('skills') ? 'sm:mt-10 md:mt-36 mt-32' : 'sm:mt-4 md:mt-0 mt-4'}`}>পেশাগত  <span className='text-rose-600 md:text-6xl text-4xl'>
                            দক্ষতা
                        </span>
                            {/* <hr className='mx-auto mt-4 ' width="230px" /> */}
                        </h1>
                        <div className=' -mt-[56px]  text-center lg:w-[530px] md:w-[445px] sm:w-[280px] w-[280px] h-[70px]       wavy'></div>
                    </>
            }




            {/* Original Div for Skills */}
            {/* <div className='mt-12 grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-2 gap-y-16 animation' data-aos="fade-down">

                <div className='animate-pulse mx-auto rounded-xl glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                    <FaHtml5 className='text-8xl text-center text-orange-500'></FaHtml5>
                    <p className='text-xl mx-auto ml-3 my-1  absolute cursor-pointer mt-3 group-hover:invisible text-orange-500'>HTML5</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-orange-500 text-[22px] mx-auto ml-2 my-1 absolute cursor-pointer mt-2'>HTML5</p>
                    </div>
                </div>

                <div className='animate-pulse mx-auto rounded-xl glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                    <SiCss3 className='text-[82px] text-center text-blue-500 mt-1'></SiCss3>
                    <p className='text-xl mx-auto ml-4 mt-6  absolute cursor-pointer group-hover:invisible text-blue-500'>CSS3</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-blue-500 text-2xl mx-auto ml-3 my-[5px]  absolute cursor-pointer mt-4'>CSS3</p>
                    </div>
                </div>


                <div className='animate-pulse mx-auto rounded-xl glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group  transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                    <FaBootstrap className='text-8xl text-center text-blue-600'></FaBootstrap>
                    <p className='text-xl mx-auto ml-1 my-1  absolute cursor-pointer mt-2 group-hover:invisible text-blue-600'>Bootstrap</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-blue-600 text-2xl mx-auto  my-1  absolute cursor-pointer mt-2'>Bootstrap</p>
                    </div>
                </div>

                <div className='animate-pulse mx-auto rounded-xl glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                    <SiTailwindcss className='text-8xl text-center text-sky-500'></SiTailwindcss>
                    <p className='text-xl mx-auto ml-3 my-1  absolute cursor-pointer mt-3 group-hover:invisible text-sky-500'>Tailwind</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-sky-500 text-2xl mx-auto my-1 ml-2 absolute cursor-pointer mt-2'>Tailwind</p>
                    </div>
                </div>


                <div className='animate-pulse mx-auto rounded-xl glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                    <DiJavascript1 className='text-8xl text-center text-yellow-500'></DiJavascript1>
                    <p className='text-xl mx-auto ml-2 my-1  absolute cursor-pointer mt-3 group-hover:invisible text-yellow-500'>JavaScript</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-yellow-500 text-[23px] mx-auto ml-0 my-1  absolute cursor-pointer mt-2'>JavaScript</p>
                    </div>
                </div>




                <div className='animate-pulse mx-auto rounded-xl  glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group   transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                    <FaReact className='text-8xl text-center text-cyan-500'></FaReact>
                    <p className='text-xl mx-auto ml-4 my-1  absolute cursor-pointer mt-3 group-hover:invisible text-cyan-500'>React</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-cyan-500 text-2xl mx-auto ml-4 my-1  absolute cursor-pointer mt-2 '>React</p>
                    </div>
                </div>


                <div className='animate-pulse mx-auto rounded-xl glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group   transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                    <FaNodeJs className='text-8xl text-center text-green-600'></FaNodeJs>
                    <p className='text-green-600 text-xl mx-auto ml-2 my-1  absolute cursor-pointer mt-3 group-hover:invisible'>Node JS</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-green-600 text-2xl mx-auto ml-1 my-1  absolute cursor-pointer mt-3'>Node JS</p>
                    </div>
                </div>

                <div className='animate-pulse mx-auto rounded-xl glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                    <SiMongodb className='text-8xl text-center text-green-500'></SiMongodb>
                    <p className='text-xl mx-auto ml-1 my-1  absolute cursor-pointer mt-3 group-hover:invisible text-green-500'>MongoDB</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-green-500 text-[21px] mx-auto ml-1 my-1  absolute cursor-pointer mt-2'>MongoDB</p>
                    </div>
                </div>

                <div className='animate-pulse mx-auto rounded-xl glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group   transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                    <SiRedux className='text-8xl text-center font-bold text-violet-700'></SiRedux>
                    <p className='text-xl mx-auto ml-4 my-1  absolute cursor-pointer mt-3 group-hover:invisible text-violet-600'>Redux</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-violet-600 text-2xl mx-auto ml-3 my-1  absolute cursor-pointer mt-2 '>Redux</p>
                    </div>
                </div>

                <div className='animate-pulse mx-auto rounded-xl glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group   transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                    <SiFirebase className='text-8xl text-center font-bold text-yellow-600'></SiFirebase>
                    <p className='text-xl mx-auto ml-2 my-1  absolute cursor-pointer mt-3 group-hover:invisible text-yellow-600'>Firebase</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-yellow-600 text-[22px] mx-auto ml-2 my-1  absolute cursor-pointer mt-2 '>Firebase</p>
                    </div>
                </div>

            </div> */}










































            <div className='mt-12 grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-2 gap-y-16 animation' data-aos="fade-down">


                <div className='animate-pulse mx-auto rounded-xl glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300  newContainer relative cursor-pointer'
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <FaHtml5 className='text-8xl text-center text-orange-500'></FaHtml5>
                    <p className='text-xl mx-auto ml-3 my-1  absolute cursor-pointer mt-28 group-hover:invisible text-orange-500 '>HTML5</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-orange-500 text-[22px] mx-auto -ml-[85px] my-1 absolute cursor-pointer mt-28'>HTML5</p>
                    </div>
                    <div className=' overlay lg:block xl:block 2xl:block hidden'>
                        <div className='content text-center'>
                            {
                                countOn &&
                                <>
                                    <p className='text-center'> <CountUp start={0} end={5} delay={0} duration={7} className='font-bold text-purple-500 text-center text-6xl px-4 mx-auto'></CountUp></p>
                                    <h1 className=' px-4 text-black font-serif font-bold text-lg  capitalize'>Complete Projects using HTML</h1>
                                </>
                            }
                        </div>
                    </div>

                </div>


                <div className='animate-pulse mx-auto rounded-xl glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 newContainer relative cursor-pointer'
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <SiCss3 className='text-[82px] text-center text-blue-500 mt-1'></SiCss3>
                    <p className='text-xl mx-auto ml-4 mt-28  absolute cursor-pointer group-hover:invisible text-blue-500'>CSS3</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-blue-500 text-2xl mx-auto -ml-[70px] my-[5px]  absolute cursor-pointer mt-28'>CSS3</p>
                    </div>
                    <div className=' overlay lg:block xl:block 2xl:block hidden'>
                        <div className='content text-center'>
                            {
                                countOn &&
                                <>
                                    <p className='text-center'> <CountUp start={0} end={3} delay={0} duration={7} className='font-bold text-purple-500 text-center text-6xl px-4 mx-auto'></CountUp></p>
                                    <h1 className=' px-4 text-black font-serif font-bold text-lg  capitalize'>Complete Projects using HTML and Vanilla CSS</h1>
                                </>
                            }
                        </div>
                    </div>
                </div>

                <div className='animate-pulse mx-auto rounded-xl glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group  transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 newContainer relative cursor-pointer'
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <FaBootstrap className='text-8xl text-center text-blue-600'></FaBootstrap>
                    <p className='text-xl mx-auto ml-1 my-1  absolute cursor-pointer mt-28 group-hover:invisible text-blue-600'>Bootstrap</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-blue-600 text-2xl mx-auto  my-1  absolute cursor-pointer mt-28 -ml-[98px]'>Bootstrap</p>
                    </div>
                    <div className=' overlay lg:block xl:block 2xl:block hidden'>
                        <div className='content text-center'>
                            {
                                countOn &&
                                <>
                                    <p className='text-center'> <CountUp start={0} end={8} delay={0} duration={9} className='font-bold text-purple-600 text-center text-[49px] px-4 mx-auto'></CountUp></p>
                                    <h1 className='-mt-2 px-4 text-black font-serif font-bold text-lg  capitalize'>Complete Projects using Bootstrap</h1>
                                </>
                            }
                        </div>
                    </div>
                </div>






                <div className='animate-pulse mx-auto rounded-xl glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 newContainer1 relative cursor-pointer'
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <SiTailwindcss className='text-8xl text-center text-sky-500'></SiTailwindcss>
                    <p className='text-xl mx-auto ml-3 my-1  absolute cursor-pointer mt-4 group-hover:invisible text-sky-500'>Tailwind</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-sky-500 text-2xl mx-auto my-1 absolute cursor-pointer mt-4 ml-[7px]'>Tailwind</p>
                    </div>
                    <div className=' overlay1 lg:block xl:block 2xl:block hidden'>
                        <div className='content1 text-center'>
                            {
                                countOn &&
                                <>
                                    <p className='text-center'> <CountUp start={0} end={6} delay={0} duration={7} className='font-bold text-purple-600 text-center text-[48px] px-4 mx-auto'></CountUp></p>
                                    <h1 className=' -mt-2 px-4 text-black font-serif font-bold text-lg  capitalize'>Complete Projects using Tailwind CSS</h1>
                                </>
                            }
                        </div>
                    </div>
                </div>


                <div className='animate-pulse mx-auto rounded-xl glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 newContainer relative cursor-pointer'
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <DiJavascript1 className='text-8xl text-center text-yellow-500'></DiJavascript1>
                    <p className='text-xl mx-auto ml-2 my-1  absolute cursor-pointer mt-28 group-hover:invisible text-yellow-500'>JavaScript</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-yellow-500 text-[23px] mx-auto -ml-[100px] my-1  absolute cursor-pointer mt-28'>JavaScript</p>
                    </div>
                    <div className=' overlay lg:block xl:block 2xl:block hidden'>
                        <div className='content text-center'>
                            {
                                countOn &&
                                <>
                                    <p className='text-center'> <CountUp start={0} end={4} delay={0} duration={6} className='font-bold text-purple-600 text-center text-[48px] px-4 mx-auto'></CountUp></p>
                                    <h1 className=' -mt-2 px-4 text-black font-serif font-bold text-lg  capitalize'>Complete Projects using Vanilla JavaScript</h1>
                                </>
                            }
                        </div>
                    </div>
                </div>




                <div className='animate-pulse mx-auto rounded-xl  glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group   transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 newContainer relative cursor-pointer'
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <FaReact className='text-8xl text-center text-cyan-500'></FaReact>
                    <p className='text-xl mx-auto ml-5 my-1  absolute cursor-pointer mt-28 group-hover:invisible text-cyan-500'>React</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-cyan-500 text-2xl mx-auto -ml-[75px] my-1  absolute cursor-pointer mt-28 '>React</p>
                    </div>
                    <div className=' overlay lg:block xl:block 2xl:block hidden'>
                        <div className='content text-center'>
                            {
                                countOn &&
                                <>
                                    <p className='text-center'> <CountUp start={0} end={9} delay={0} duration={7} className='font-bold text-purple-600 text-center text-6xl px-4 mx-auto'></CountUp></p>
                                    <h1 className=' px-4 text-black font-serif font-bold text-lg  capitalize'>Complete Projects using React JS</h1>
                                </>
                            }
                        </div>
                    </div>
                </div>


                <div className='animate-pulse mx-auto rounded-xl glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group   transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 newContainer relative cursor-pointer'
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <FaNodeJs className='text-8xl text-center text-green-600'></FaNodeJs>
                    <p className='text-green-600 text-xl mx-auto ml-2 my-1  absolute cursor-pointer mt-28 group-hover:invisible'>Node JS</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-green-600 text-2xl mx-auto -ml-[90px] my-1  absolute cursor-pointer mt-28'>Node JS</p>
                    </div>
                    <div className=' overlay lg:block xl:block 2xl:block hidden'>
                        <div className='content text-center'>
                            {
                                countOn &&
                                <>
                                    <p className='text-center'> <CountUp start={0} end={7} delay={0} duration={6} className='font-bold text-purple-600 text-center text-5xl px-4 mx-auto'></CountUp></p>
                                    <h1 className=' px-4 text-black font-serif font-bold text-lg  capitalize'>Complete Projects using Node JS and Express JS</h1>
                                </>
                            }
                        </div>
                    </div>
                </div>

                <div className='animate-pulse mx-auto rounded-xl glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 newContainer1 relative cursor-pointer'
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <SiMongodb className='text-8xl text-center text-green-500'></SiMongodb>
                    <p className='text-xl mx-auto ml-1 my-1  absolute cursor-pointer mt-4 group-hover:invisible text-green-500'>MongoDB</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-green-500 text-[21px] mx-auto ml-[5px] my-1  absolute cursor-pointer mt-4'>MongoDB</p>
                    </div>
                    <div className=' overlay1 lg:block xl:block 2xl:block hidden'>
                        <div className='content1 text-center'>
                            {
                                countOn &&
                                <>
                                    <p className='text-center'> <CountUp start={0} end={7} delay={0} duration={6} className='font-bold text-purple-600 text-center text-5xl px-4 mx-auto'></CountUp></p>
                                    <h1 className=' px-4 text-black font-serif font-bold text-lg  capitalize'>Complete Projects using MongoDB</h1>
                                </>
                            }
                        </div>
                    </div>
                </div>

                <div className='animate-pulse mx-auto rounded-xl glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group   transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 newContainer relative cursor-pointer'
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <SiRedux className='text-8xl text-center font-bold text-violet-700'></SiRedux>
                    <p className='text-xl mx-auto ml-4 my-1  absolute cursor-pointer mt-28 group-hover:invisible text-violet-600'>Redux</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-violet-600 text-2xl mx-auto -ml-[85px] my-1  absolute cursor-pointer mt-28 '>Redux</p>
                    </div>
                    <div className=' overlay lg:block xl:block 2xl:block hidden'>
                        <div className='content text-center'>
                            {
                                countOn &&
                                <>
                                    <p className='text-center'> <CountUp start={0} end={5} delay={0} duration={8} className='font-bold text-purple-600 text-center text-5xl px-4 mx-auto'></CountUp></p>
                                    <h1 className='px-4 text-black font-serif font-bold text-[17px]  capitalize'>Complete Projects using Redux Thunk and RTK Query</h1>
                                </>
                            }
                        </div>
                    </div>
                </div>

                <div className='animate-pulse mx-auto rounded-xl glass px-4 py-2 hover:px-4 hover:py-2 hover:rounded-3xl group   transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 newContainer relative cursor-pointer'
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave} >
                    <SiFirebase className='text-8xl text-center font-bold text-yellow-600'></SiFirebase>
                    <p className='text-xl mx-auto ml-2 my-1  absolute cursor-pointer mt-28 group-hover:invisible text-yellow-600'>Firebase</p>
                    <div className='invisible group-hover:visible'>
                        <p className='text-yellow-600 text-[22px] mx-auto -ml-[85px] my-1  absolute cursor-pointer mt-28 '>Firebase</p>
                    </div>
                    <div className=' overlay lg:block xl:block 2xl:block hidden'>
                        <div className='content text-center'>
                            {
                                countOn &&
                                <>
                                    <p className='text-center'> <CountUp start={0} end={12} delay={0} duration={8} className='font-bold text-purple-600 text-center text-[50px] px-4 mx-auto'></CountUp></p>
                                    <h1 className=' -mt-2 px-4 text-black font-serif font-bold text-lg  capitalize'>Complete Projects using Firebase</h1>
                                </>
                            }
                        </div>
                    </div>
                </div>

            </div>




































            {
                showDetails &&

                <div className='text-center mt-24 mb-4 grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-2 gap-y-16 mx-8'>


                    <div className='w-3/4 mx-auto rounded-xl animation' data-aos='fade-right'>
                        <div className="radial-progress text-orange-500 mt-5  mx-auto" style={{ "--value": "80", "--size": "8rem", "--thickness": "7px" }}>
                            <FaHtml5 className='text-6xl text-center text-orange-500 mt-2'></FaHtml5>
                            {/* <h1 className='text-xl '> 90%</h1> */}
                        </div>
                        <h1 className='text-lg ml-4 mt-3 '>HTML5</h1>
                    </div>

                    <div className='w-3/4 mx-auto rounded-xl animation' data-aos='fade-right'>
                        <div className="radial-progress text-blue-600 mt-5  mx-auto" style={{ "--value": "80", "--size": "8rem", "--thickness": "7px" }}>
                            <SiCss3 className='text-[53px] text-center text-blue-500 mt-2'></SiCss3>
                            {/* <h1 className='text-xl '> 90%</h1> */}
                        </div>
                        <h1 className='text-lg ml-4 mt-3 '>CSS3</h1>
                    </div>



                    <div className='w-3/4 mx-auto rounded-xl animation' data-aos='fade-right'>
                        <div className="radial-progress text-blue-600 mt-5  mx-auto" style={{ "--value": "80", "--size": "8rem", "--thickness": "7px" }}>
                            <FaBootstrap className='text-6xl text-center text-blue-600 mt-2'></FaBootstrap>
                            {/* <h1 className='text-xl '> 90%</h1> */}
                        </div>
                        <h1 className='text-lg ml-4 mt-3 '>Bootstrap</h1>
                    </div>

                    <div className='w-3/4 mx-auto rounded-xl animaion' data-aos='fade-right'>
                        <div className="radial-progress text-sky-600 mt-5  mx-auto" style={{ "--value": "90", "--size": "8rem", "--thickness": "7px" }}>
                            <SiTailwindcss className='text-6xl text-center text-sky-500 mt-2'></SiTailwindcss>
                            {/* <h1 className='text-xl '> 90%</h1> */}
                        </div>
                        <h1 className='text-lg ml-4 mt-3 '>Tailwind</h1>
                    </div>

                    <div className='w-3/4 mx-auto rounded-xl animation' data-aos='fade-left'>
                        <div className="radial-progress text-yellow-600 mt-5  mx-auto" style={{ "--value": "70", "--size": "8rem", "--thickness": "7px" }}>
                            <DiJavascript1 className='text-6xl text-center mt22 text-yellow-500'></DiJavascript1>
                            {/* <h1 className='text-xl '> 70%</h1> */}
                        </div>
                        <h1 className='text-lg ml-4 mt-3 '>JavaScript</h1>
                    </div>


                    <div className='w-3/4 mx-auto rounded-xl animation' data-aos='fade-left'>
                        <div className="radial-progress text-cyan-500 mt-5  mx-auto" style={{ "--value": "80", "--size": "8rem", "--thickness": "7px" }}>
                            <FaReact className='text-6xl text-center text-cyan-500 mt-2'></FaReact>
                            {/* <h1 className='text-xl '> 80%</h1> */}
                        </div>
                        <h1 className='text-lg ml-1 mt-3 '>React</h1>
                    </div>

                    <div className='w-3/4 mx-auto rounded-xl animation' data-aos='fade-left'>
                        <div className="radial-progress text-green-600 mt-5  mx-auto" style={{ "--value": "60", "--size": "8rem", "--thickness": "7px" }}>
                            <FaNodeJs className='text-6xl text-center text-green-600 mt-2'></FaNodeJs>
                            {/* <h1 className='text-xl '> 50%</h1> */}
                        </div>
                        <h1 className='text-lg ml-4 mt-3 '>Node JS</h1>
                    </div>


                    <div className='w-3/4 mx-auto rounded-xl animation' data-aos='fade-left'>
                        <div className="radial-progress text-green-600 mt-5  mx-auto" style={{ "--value": "75", "--size": "8rem", "--thickness": "7px" }}>
                            <SiMongodb className='text-6xl text-center mt-2 text-green-500'></SiMongodb>
                            {/* <h1 className='text-xl '> 75%</h1> */}
                        </div>
                        <h1 className='text-lg ml-5 mt-3 '>MongoDB</h1>
                    </div>


                    <div className='w-3/4 mx-auto rounded-xl animation' data-aos='fade-left'>
                        <div className="radial-progress text-violet-800 mt-5  mx-auto" style={{ "--value": "60", "--size": "8rem", "--thickness": "7px" }}>
                            <SiRedux className='text-6xl text-center mt-2 text-violet-700'></SiRedux>
                            {/* <h1 className='text-xl '> 60%</h1> */}
                        </div>
                        <h1 className='text-lg ml-5 mt-3 '>Redux</h1>
                    </div>


                    <div className='w-3/4 mx-auto rounded-xl animation' data-aos='fade-left'>
                        <div className="radial-progress text-yellow-600 mt-5  mx-auto" style={{ "--value": "70", "--size": "8rem", "--thickness": "7px" }}>
                            <SiFirebase className='text-6xl text-center mt-2 text-yellow-500'></SiFirebase>
                            {/* <h1 className='text-xl '> 70%</h1> */}
                        </div>
                        <h1 className='text-lg ml-5 mt-3 '>Firebase</h1>
                    </div>

                </div>
            }


            <Wave className='mt-12  h-[26px]' mask="url(#mask)" fill="#650c7b" >
                <defs>
                    <linearGradient id="gradient" gradientTransform="rotate(90)">
                        <stop offset="0" stopColor="white" />
                        <stop offset="0.5" stopColor="black" />
                    </linearGradient>
                    <mask id="mask">
                        <rect x="0" y="0" width="2200" height="170" fill="url(#gradient)" />
                    </mask>
                </defs>
            </Wave>



            {
                language === 'english' ?
                    <div className='mx-auto text-center mt-16'>
                        <button onClick={handleViewDetails} className='text-lg px-6 py-2 bg-gradient-to-r from-violet-900 to-pink-700 rounded-sm text-white'>{showDetails ? 'Hide Details' : 'Show Details'}</button>
                    </div>
                    :
                    <div className='mx-auto text-center mt-16'>
                        <button onClick={handleViewDetails} className='text-lg px-6 py-2 bg-gradient-to-r from-violet-900 to-pink-700 rounded-sm text-white'>{showDetails ? 'বিস্তারিত লুকান' : 'বিস্তারিত দেখুন'}</button>
                    </div>
            }


        </div>
    );
};

export default Skills2;